import { render, staticRenderFns } from "./OrderAmount.vue?vue&type=template&id=7f0f2630&scoped=true"
import script from "./OrderAmount.vue?vue&type=script&lang=js"
export * from "./OrderAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0f2630",
  null
  
)

export default component.exports